import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Trans } from 'react-i18next'

import BaseModal from 'components/Modals/BaseModal'
import { Button } from 'components/Forms'
import { closeModal } from 'store/actions/modals'
import { t } from 'translations'
import { Format } from 'services/Dates'
import { DateTime } from 'components/UI'
import { Alert, Button as MerinioButton, List } from 'ui'
import { getPositionName } from 'services/Utilities'

const SelectPunchAction = ({ lng, locale, onClose, punchOutOfShift, unPunchedCards }) => {
  const dispatch = useDispatch()
  const [cardActedOn, setCardActedOn] = useState({})
  return (
    <BaseModal hideButtons title="punch.DETECTED_SOME_PUNCH_ISSUES" tOptions={{ lng }}>
      <Alert variant="info">{t('punch.DETECTED_SOME_PUNCH_ISSUES.DESC', { lng })}</Alert>
      {t('punch.YOU_HAVENT_PUNCH_OUT_THESE_SHIFT', { lng })}
      <List>
        {unPunchedCards.map(card => (
          <List.Item key={card._id}>
            {card.start && card.end ? (
              <div>
                <DateTime date={card.start} outFormat="humanDateSemiCompact" options={{ locale }} />{' '}
                <DateTime date={[card.start, card.end]} range outFormat="time" options={{ locale }} />
              </div>
            ) : (
              <Trans t={t} i18nKey="punch.DETECTED_SOME_PUNCH_ISSUES.PUNCHED_IN_AT">
                <b>{{ time: Format(card.arrival, { outFormat: 'humanDateTimeEmphasisTime' }) }}</b>
              </Trans>
            )}
            <b>{getPositionName(card.positionId)}</b>
            <span className="float-right">
              <MerinioButton
                color="secondary"
                onClick={() => {
                  punchOutOfShift(card)
                  setCardActedOn({ ...cardActedOn, [card._id]: true })
                }}
                disabled={cardActedOn[card._id]}
                outlined
              >
                {t('punch.PUNCH_OUT', { lng })}
              </MerinioButton>
            </span>
          </List.Item>
        ))}
      </List>

      <div className="mt-3">
        <MerinioButton
          type="button"
          color="primary"
          className="mr-1"
          onClick={() => {
            onClose()
          }}
        >
          {t('punch.PUNCH_IN', { lng })}
        </MerinioButton>
        <Button color="secondary" outlined onClick={() => dispatch(closeModal())}>
          {t(`actions.CLOSE`, { lng })}
        </Button>
      </div>
    </BaseModal>
  )
}

export default SelectPunchAction
